var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('inside-header'),_c('div',[_vm._v(" 我从不轻易认输，直到陪孩子读书我从不轻易认输，直到陪孩子读书 ")]),_c('hr'),_c('div')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }